export default {
    config: {},
    default: {},
    unique: [],
    sort: false,
    lang: {
        name: 'Year Published',
        category: 'Game',
        description: 'The year a game was published.',
    },
    filters: ['bgg.rating.votes']
}